<template>
    <div class="modal fade" id="solicitar_credito">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">¡Solicita tu credito!</h4>
                </div>
                <div class="modal-body">
                    <b-alert v-model="ifSuccess" variant="success" dismissible>
                        Se envio correctamente!
                    </b-alert>
                    <form @submit.prevent="onCreditoForm">
                        <h6 class="text-modal">
                            Diligencie la siguiente información, uno de nuestros
                            asesores se pondrá en contacto con usted para
                            brindarle una mejor asesoría.
                        </h6>
                        <b-card>
                            <b-row>
                                <b-col md="3" class="text-center mb-2">
                                    <!-- Imagen principal del vehículo -->
                                    <img
                                        :src="main_image"
                                        class="img-fluid"
                                        alt="image"
                                    />
                                </b-col>
                                <b-col md="9">
                                    <div>
                                        <h4 class="m-0">
                                            <i class="fa fa-car"></i>
                                            {{ vehiculoData.marca }}
                                            {{ vehiculoData.linea }}
                                        </h4>
                                        <h5 class="grey-text">
                                            {{ vehiculoData.modelo }} |
                                            {{
                                                vehiculoData.kilometraje
                                                    | formatNumber
                                            }}
                                            km
                                        </h5>
                                        <h5 class="text-red">
                                            ${{
                                                vehiculoData.precio_publicacion
                                                    | formatNumber
                                            }}
                                        </h5>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card>
                        <b-row class="mt-2">
                            <b-col>
                                <div class="form-group">
                                    <input
                                        v-model="form.nombre"
                                        type="text"
                                        class="form-control"
                                        placeholder="Nombre"
                                    />
                                </div>
                            </b-col>
                            <b-col>
                                <div class="form-group">
                                    <input
                                        v-model="form.apellido"
                                        type="text"
                                        class="form-control"
                                        placeholder="Apellido"
                                    />
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <input
                                        v-model="form.email"
                                        type="email"
                                        class="form-control"
                                        placeholder="Correo electrónico"
                                    />
                                </div>
                            </b-col>
                            <b-col>
                                <div class="form-group">
                                    <input
                                        v-model="form.celular"
                                        type="number"
                                        class="form-control"
                                        placeholder="Celular"
                                        maxlength="10"
                                    />
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <vue-autonumeric
                                        id="input-horizontal"
                                        class="form-control"
                                        v-model="form.precio"
                                        :options="optionsNumeric"
                                        placeholder="Valor del vehículo"
                                        disabled
                                    ></vue-autonumeric>
                                </div>
                            </b-col>
                            <b-col>
                                <div class="form-group">
                                    <vue-autonumeric
                                        id="input-horizontal"
                                        class="form-control"
                                        v-model="form.financiar"
                                        :options="optionsNumeric"
                                        placeholder="Valor a financiar"
                                    ></vue-autonumeric>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <input
                                        v-model="form.actividad"
                                        type="text"
                                        class="form-control"
                                        placeholder="Actividad Economica"
                                    />
                                </div>
                            </b-col>
                            <b-col>
                                <div class="form-group">
                                    <vue-autonumeric
                                        id="input-horizontal"
                                        class="form-control"
                                        v-model="form.ingresos"
                                        :options="optionsNumeric"
                                        placeholder="Ingresos"
                                    ></vue-autonumeric>
                                </div>
                            </b-col>
                        </b-row>
                        <div class="form-group">
                            <textarea
                                v-model="form.mensaje"
                                rows="2"
                                class="form-control"
                                placeholder="Mensaje"
                            ></textarea>
                        </div>
                        <div class="form-group">
                            <label>
                               <i class="fa fa-check-square" aria-hidden="true"></i>
                                Al solicitar tu credito estás aceptando
                                nuestra
                                <a
                                    href="https://redautos.com/politica_tratamiento_datos_personales"
                                    target="_blank"
                                >
                                    Política de privacidad de datos personales
                                </a>
                            </label>
                        </div>
                        <div class="form-group">
                            <button
                                :disabled="onLoadForm"
                                class="btn btn-block"
                                type="submit"
                            >
                                Aplicar a Credito
                                <clip-loader
                                    :class="{ 'd-none': !onLoadForm }"
                                    style="display: inline;margin-right: 10px;"
                                    color="#fff"
                                    size="15px"
                                ></clip-loader>
                                <span
                                    :class="{ 'd-none': onLoadForm }"
                                    class="angle_arrow"
                                >
                                    <i
                                        class="fa fa-angle-right"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        vehiculoData() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo
                .vehiculo;
        },
        idReporte() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo
                .id_reporte;
        },
        fotosData() {
            return this.$store.state.fichaTecnica.vehiculo.fotos;
        }
    },
    created() {
        this.form.precio = this.vehiculoData.precio_publicacion;
        this.main_image =
            "https://brokcars-assets.s3.us-east-2.amazonaws.com/" +
            this.fotosData.foto_principal;
        this.marca_linea_version = `${this.vehiculoData.marca} ${this.vehiculoData.linea} ${this.vehiculoData.version} ${this.vehiculoData.modelo}`;
    },
    data: () => ({
        onLoadForm: false,
        ifSuccess: false,
        marca_linea_version: "",
        form: {
            nombre: "",
            apellido: "",
            email: "",
            celular: "",
            precio: "",
            financiar: "",
            actividad: "",
            ingresos: "",
            mensaje: ""
        },
        optionsNumeric: [
            "integerPos",
            {
                digitGroupSeparator: ".",
                decimalCharacter: ",",
                minimumValue: "0",
                maximumValue: "99999999999"
            }
        ]
    }),
    methods: {
        resetForm() {
            this.form = {
                nombre: "",
                apellido: "",
                email: "",
                celular: "",
                precio: "",
                financiar: "",
                actividad: "",
                ingresos: "",
                mensaje: ""
            };
        },
        onCreditoForm() {
            this.onLoadForm = true;
            //this.onErrorMsg = false;
            //this.arrayErrors = [];
            var {
                nombre,
                apellido,
                mensaje,
                precio,
                financiar,
                actividad,
                ingresos,
                celular,
                email
            } = this.form;
            var vehiculo =
                this.vehiculoData.marca +
                " " +
                this.vehiculoData.linea +
                " " +
                this.vehiculoData.modelo +
                " - " +
                this.vehiculoData.version;
            axios
                .post("/ajax/credito_form", {
                    id_reporte: this.idReporte,
                    vr_financiar: financiar,
                    actividad: actividad,
                    ingresos: ingresos,
                    nombre: nombre + " " + apellido,
                    email: email,
                    celular: celular,
                    vehiculo: vehiculo,
                    mensaje:
                        mensaje +
                        " - Valor vehiculo: " +
                        precio +
                        " - Valor financiar: " +
                        financiar +
                        " - Actividad: " +
                        actividad +
                        " - Ingresos: " +
                        ingresos
                })
                .then(response => {
                    $("#solicitar_credito").modal("hide");
                    this.$swal.fire({
                        icon: "success",
                        title: "Solictud de credito",
                        text:
                            "¡Para continuar con el proceso de solicitud de credito, uno de nuestros asesores se comunicara con usted!",
                        confirmButtonColor: "#858796"
                    });
                    var parseRes = response.data;
                    this.onLoadForm = false;
                    this.ifSuccess = true;
                    this.resetForm();
                    /**if(parseRes.response == 'error'){
                    this.onErrorMsg = true;
                    this.arrayErrors = parseRes.errors;
                    this.onLoadForm = false;
                }else{
                    setTimeout(function(){
                    window.location.href = '/admin/home';
                    }, 500);
                }**/
                });
        }
    }
};
</script>

<style lang="scss">
h5.text-red {
    color: #fa2837;
}
</style>
